<div *ngIf="showApplyJobRole" class="cg-margin-bottom-md">
  <button
    cignaButton="link"
    style="padding-left: 0"
    class="cg-pipe-link"
    data-test="apply-role-link"
    (click)="applyByRole()"
  >
    Apply entitlements based on Job role
  </button>
  <span *ngIf="showRevert">|</span>
  <button
    cignaButton="link"
    *ngIf="showRevert"
    class="cg-pipe-link"
    data-test="revert-access-link"
    (click)="revert()"
  >
    Revert to existing access
  </button>
</div>
<div style="clear: both" class="cg-multicolumn-list cg-multi-column-list-lg-2">
  <ng-container *ngFor="let entitlement of allEntitlements">
    <div class="cg-multicolumn-list__item">
      <label
        class="cg-indent-label-text"
        [attr.data-test]="'txt-entitlement' + entitlement.id"
        [class.disabled]="isEntitlementDisabled(entitlement, bulkEdit)"
      >
        <input
          #entitlementInput
          class="cg-indent-label-text__input"
          type="checkbox"
          [disabled]="isEntitlementDisabled(entitlement, bulkEdit)"
          [value]="entitlement.id"
          [checked]="activeEntitlement(entitlement.id)"
          (change)="entitlementChange(entitlement)"
          [attr.data-test]="'chk-entitlement-' + entitlement.id"
        />
        {{ entitlement.description }}
      </label>
      <ng-container *ngIf="entitlement.functions">
        <ng-container *ngFor="let function of entitlement.functions">
          <div
            class="cg-multicolumn-list__item"
            style="margin-left: 15px; margin-top: -5px"
            *ngIf="function.name !== 'Claim status notifications'"
          >
            <label
              class="cg-indent-label-text"
              [class.disabled]="isEntitlementDisabled(entitlement, bulkEdit)"
            >
              <input
                #functionsInput
                class="cg-indent-label-text__input subCheckBox"
                [disabled]="isEntitlementDisabled(entitlement, bulkEdit)"
                (change)="functionChange(entitlement)"
                type="checkbox"
                [attr.data-test]="function.name"
                [value]="function.name"
                [checked]="activeFunction(entitlement.id, function.name)"
              />
              {{ function.name }}
            </label>
          </div>
        </ng-container>
      </ng-container>
      <span
        *ngIf="bulkEdit && isEntitlementDisabled(entitlement, bulkEdit)"
        style="display: block; margin: -5px 0 15px 15px"
      >
        (<i>cannot change existing access using bulk edit</i>)
      </span>
    </div>
  </ng-container>
</div>
